import Loadable from '../../components/loadable';

const BulkMobileAppChanges = Loadable({
  loader: () => import('../../pages/reports/bulk_mobile_app_changes'),
});

angular.module('gym').value('BulkMobileAppChanges', BulkMobileAppChanges);

const BulkMobileAppChangesFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/reports/bulk_mobile_app_changes/bulk_mobile_app_changes_filters_modal'
    ),
  type: 'modal',
});

angular
  .module('gym')
  .value('BulkMobileAppChangesFiltersModal', BulkMobileAppChangesFiltersModal);
